(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoItemReportController', InvoiceInfoItemReportController);

    InvoiceInfoItemReportController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CompanyCustom', 'DateUtils'];

    function InvoiceInfoItemReportController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate, CompanyCustom, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';

        vm.invoiceInfoStatus = "";
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.doBeforeExport = doBeforeExport;


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
            });
        }


        loadAll();

        function loadAll() {

            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                vm.serviceItems.push({id: 0, itemTitle: "همه خدمات"})
                vm.serviceItemId = 0;
                //if(items && items.length>0) {
                //
                //    vm.serviceItemId = items[0].id;
                //}
            });

            findCurrentCompany();

        }


        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_invoice_info_item_report',
                parameters: [{
                    name: 'p_company_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'p_status', value: (vm.invoiceInfoStatus) ? vm.invoiceInfoStatus : 'null', type: 'string'},
                    {name: 'p_service_item_id', value: (vm.serviceItemId) ? vm.serviceItemId : 'null', type: 'long'},
                    {name: 'p_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'p_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'},
                    {name: 'p_query', value: (vm.query) ? vm.query : 'null', type: 'string'}
                ]
            };
            return report_config;
        }
    }
})();
